import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ButtonBase from '@mui/material/ButtonBase';
import { APP_DEFAULT_PATH } from './../../config';
import { Box } from '@mui/system';

export default function LogoSection({ isIcon, sx, to }) {
  return (
    <ButtonBase disableRipple component={Link} to={to || APP_DEFAULT_PATH} sx={sx} aria-label="Logo">
      {!isIcon && (
        <Box
          component="img"
          src="/loader.webp"
          alt="Company"
          sx={{
            width: 200,
            height: 100,
            opacity: 0.95,
            my: -6
          }}
        />
      )}
    </ButtonBase>
  );
}

LogoSection.propTypes = { reverse: PropTypes.bool, isIcon: PropTypes.bool, sx: PropTypes.any, to: PropTypes.any };
